import type { SVGProps } from 'react'

export function UserCardId(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M5.33333 18.3333C5.40406 18.3333 5.47696 18.3333 5.55212 18.3333H12M5.33333 18.3333C4.23525 18.3324 3.65926 18.3187 3.21311 18.0914C2.79497 17.8783 2.45526 17.5375 2.24221 17.1193C2 16.644 2 16.0226 2 14.778V8.55577C2 7.31121 2 6.68847 2.24221 6.21311C2.45526 5.79497 2.79497 5.45526 3.21311 5.24221C3.68847 5 4.31121 5 5.55577 5H18.4447C19.6892 5 20.3106 5 20.786 5.24221C21.2041 5.45526 21.545 5.79497 21.758 6.21311C22 6.688 22 7.30999 22 8.55212V14.7812C22 16.0233 22 16.6444 21.758 17.1193C21.545 17.5375 21.2041 17.8783 20.786 18.0914C20.3111 18.3333 19.69 18.3333 18.4479 18.3333H12M5.33333 18.3333C5.33338 17.106 6.82574 16.1111 8.66667 16.1111C10.5076 16.1111 12 17.106 12 18.3333M5.33333 18.3333C5.33333 18.3333 5.33333 18.3333 5.33333 18.3333ZM18.6667 13.8889H14.2222M18.6667 10.5556H15.3333M8.66667 12.7778C7.43937 12.7778 6.44444 11.7829 6.44444 10.5556C6.44444 9.32826 7.43937 8.33333 8.66667 8.33333C9.89397 8.33333 10.8889 9.32826 10.8889 10.5556C10.8889 11.7829 9.89397 12.7778 8.66667 12.7778Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  )
}
